<template>
  <div v-if="getLoggedStatus" class="agent-logged">
    <div class="console-header">
      <div class="console-buttons">
        <el-button
          @click="handleLogout"
          class="btn-close-session"
          :disabled="getIsInCall"
          >{{ $t("agent-console.buttons.close-session") }}</el-button
        >
        <el-button @click="$store.dispatch('toggleAvailableForChats')" v-if="agent.chat" :type="availableForChats ? 'normal' : 'danger'" >
          {{ availableForChats ? $t('agent-console.buttons.change-status-not-available') : $t('agent-console.buttons.change-status-available') }}
        </el-button>
        <el-button v-if="getBreakStatus.id === 0 && agent.call" :disabled="!getLoggedInCallCenter" @click="showModalBreaks">{{ $t("agent-console.buttons.got-to-break") }}</el-button>
        <el-button v-if="getBreakStatus.id > 0 && agent.call" type="danger" @click="unBreak">{{ $t("agent-console.buttons.out-of-break") }}</el-button>
        <el-button v-if="agent.call" @click="showNewCallDrawer" :disabled="!isCallButtonEnabled">{{ $t("agent-console.buttons.new-call") }}</el-button>
      </div>
      <CallButtons
        v-if="getIsInCall"
        v-loading="!janusConnected"
        element-loading-spinner="-"
        element-loading-text="Se ha perdido la conexión con el media server"
        @showTransferDrawer="showTransferDrawer"
        :janus="janus"
        :stats="stats"
        @hangupCall="hangup"
      ></CallButtons>
      <div v-else>
        <el-tooltip effect="dark" placement="bottom" v-for="(button, index) in quickDialButtons" :key="index" :content="button.label">
          <el-button circle @click="handleQuickButton(button)">
            <i class="fas fa-phone"></i>
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div style="flex: 1; display: flex">
      <div class="console" :class="{ 'show-content': getActiveItem !== null && !showAcceptChat }">
        <div class="agent-activity">
          <div class="agent-info box">
            <div class="row" style="margin-left: 0">
              <p>{{ $t("agent-console.agent") }} {{ agent.number }}</p>
            </div>
            <ul>
              <li :class="{ active: getLoggedInCallCenter }" v-if="agent.call">
                {{ $t("agent-console.call") }} ({{ textCallLogged }})
              </li>
              <li :class="{ active: getLoggedInChatCenter }" v-if="agent.chat">
                {{ $t("agent-console.chat.chat") }} ({{ textChatLogged }}) <span v-if="!availableForChats" class="not-available">{{ $t('agent-console.not-available') }}</span>
              </li>
            </ul>
            <chronometer type="clock" style="display: block"></chronometer>
          </div>
          <AgentInBreak v-if="getBreakStatus.id !== 0" :name="getBreakStatus.name" :startedAt="getBreakStatus.started_at"
            type="bar" class="agent-in-break-mobile"></AgentInBreak>
          <TheActivityBox :class="{ 'hide': getActiveItem !== null && !showAcceptChat }" style="max-width:350px" />
        </div>
        <div class="main-agent-content" :class="{ 'show': getActiveItem !== null && !showAcceptChat }">
          <el-alert v-if="agent.call && !extensionRegistered" type="warning" :closable="false">
            {{
              $t(
                "agent-console.your-extension-is-not-registered-you-will-not-receive-calls"
              )
            }}
          </el-alert>
          <AgentInBreak v-if="getBreakStatus.id !== 0" :name="getBreakStatus.name" :startedAt="getBreakStatus.started_at"
            :type="[getActiveItem || showAcceptChat ? 'bar' : 'ilustration']" class="true-break"></AgentInBreak>
          <el-alert v-if="getActiveItem &&
            getActiveItem.type === 'chat' &&
            !isAgentLogged
            " :title="$t(
    'agent-console.the-chat-is-in-read-only-mode-as-it-was-not-possible-to-log-in-correctly-as-an-agent'
  )
    " type="warning" :closable="false"></el-alert>
          <!-- <TheModalTour :title="$t('main-menu.agent-console.title')" tour="agent-console-basic" /> -->

          <TheMainAgentContent v-if="getActiveItem && Object.keys(getActiveItem).length > 0 && !showAcceptChat"
            :callKey="getActiveItem.callKey" :title="getActiveItem.title" :type="getActiveItem.type"
            :data="getActiveItem.data" :date="getActiveItem.date" :active="getActiveItem.active"
            :forms="getActiveItem.forms" :idCall="getActiveItem.id_call" :active-client="getActiveItem"
            :id="getActiveItem.key"
            @showTransferDrawer="showTransferDrawer" />
          <div v-if="!getActiveItem && getBreakStatus.id === 0 && !showAcceptChat
            " style="align-self: center; margin-top: 30%">
            <div v-if="!errorLoggin">
              <img src="@/img/undraw_Working_oh83.svg" style="width: 20vw; margin: 0 auto; display: block" />
              <p style="text-align: center; margin-top: 10px">
                {{ $t("agent-console.no-activity-selecected") }}
              </p>
            </div>
            <div v-else>
              <p style="text-align: center; margin-top: 10px">
                {{
                  $t(
                    "agent-console.errors.a-problem-has-occurred-and-you-are-not-logged"
                  )
                }}
              </p>
              <el-button @click="retry" style="margin: 0 auto; display: block">{{ $t("agent-console.retry") }}</el-button>
            </div>
          </div>
          <TheAcceptChatWindow v-if="showAcceptChat" @chatAccepted="chatAccepted" @closeWindow="closeWindow">
          </TheAcceptChatWindow>
        </div>
        <div
          :class="['agent-console__side-bar-container']"
          style="max-width:350px; display: flex; flex-direction: column; overflow-y: auto; max-height: 100vh; height: 100%; background-color: white"
          v-if="customer || clientInfo || getActiveItem?.data?.tags"
        >
        <div style="height: 100%; overflow-y: auto;" v-show="showChatDetails">
            <TheClientBox v-if="getActiveItem && getActiveItem.type === 'chat' && customer" :client="customer" />
            <TheIntegrationsBox
              v-if="integrations"
              :integrations="integrations"
            ></TheIntegrationsBox>
            <TheActivityInfoBox
              @sendEmail="showBoxSendEmail"
              @searchTicket="showBoxSearchTicket"
              @call="call"
              v-if="
                clientInfo &&
                clientInfo.length > 0
              "
              :client-info="clientInfo"
              :activity-key="getActiveItem.key"
              :crud-enabled="clientInfoCrudEnabled"
            ></TheActivityInfoBox>
            <TheTagsBox :tags="getActiveItem.data.tags" v-if="getActiveItem && getActiveItem.type === 'chat' && getActiveItem.data.tags.length > 0"></TheTagsBox>
            <TheSystemMessages :room-id="getActiveItem.data.roomId" v-if="getActiveItem && getActiveItem.type === 'chat'"></TheSystemMessages>
            <TheInternalNotesBox v-if="getActiveItem && getActiveItem.type === 'chat'" :room-id="getActiveItem.data.roomId"></TheInternalNotesBox>
            <TheSendEmailBox
              @closeEmailBox="closeEmailBox"
              :destination="sendEmailTo"
              v-if="sendEmailTo"
            ></TheSendEmailBox>
            <TheSearchTicket
              :email="searchTicketOf"
              @cancelSearchTicket="searchTicketOf = ''"
              v-if="searchTicketOf"
              ref="theSearchTicket"
            ></TheSearchTicket>
        </div>
        <div :class="['agent-console__side-bar-controls-container', {'agent-console__side-bar-controls-container--open': showChatDetails}]">
          <el-button @click="toggleShowDetails" type="text">
            <i class="agent-console__side-bar-controls fas " :class="{ 'fa-chevron-right' : showChatDetails, 'fa-chevron-left' : !showChatDetails}"></i>
          </el-button>
        </div>
      </div>
      </div>
    </div>
    <the-search-client ref="theSearchClient"></the-search-client>
    <TheNewUserDrawer ref="newUserDrawer"></TheNewUserDrawer>
    <TransferDrawer v-if="agent.call || agent.chat" ref="transferDrawer" :janus="janus" :type-transfer="typeTransfer" />
    <el-drawer
      :visible.sync="transferDrawer"
       :with-header="false"
      :close-on-press-escape="availableToClose"
      :show-close="availableToClose"
      :wrapper-closable="availableToClose"
    >
      <the-transfer-chat v-if="agent.chat && getActiveItem && getActiveItem.type === 'chat' && typeTransfer === 'chat'" @chatTransferred="transferDrawer = false" @allowClose="availableToClose = true" @denyClose="availableToClose = false"/>
      <the-transfer-call v-if="agent.call && typeTransfer === 'call'" @callTransferred="transferDrawer = false" @allowClose="availableToClose = true" @denyClose="availableToClose = false" :janus="janus"/>
    </el-drawer>
    <div v-if="agent.call">
      <NewCallDrawer ref="newCallDrawer" :janus="janus" />
      <IncomingCall :callerid="inCallWith.displayname" :janus="janus" :jsep="jsep" ref="incomingCall" :connected="!janusConnected" />
      <TheModalBreaks ref="modalBreak" />
      <audio ref loop>
        <source src="/sounds/Slow_Asus_Zenfone_5Z_Stock-635292.mp3" type="audio/ogg" />
      </audio>
      <audio ref="hangupSound">
        <source src="/sounds/hangup.mp3" type="audio/ogg" />
      </audio>
      <video ref="sipAudio" autoplay playsinline style="display: none" loop></video>
    </div>
    <div v-if="agent.chat">
      <TheConfirmationLogoutModal ref="TheConfirmationLogoutModal" />
    </div>

    <TheAgentMenu></TheAgentMenu>
  </div>
  <AgentNotSignIn v-else />
</template>

<script>
/* import agentapi from "@/api/agent"; */
import mediaServerApi from "@/api/mediaserver";
import { mapGetters, mapActions } from "vuex";
import janus from "@/plugins/janus-proxy";
import CallButtons from "@/components/agent-console/CallButtons";
import TheSystemMessages from "@/components/agent-console/TheSystemMessages";
import TheSendEmailBox from "@/components/agent-console/TheSendEmailBox";
import TheSearchTicket from "@/components/agent-console/TheSearchTicket";
import NewCallDrawer from "@/components/webrtc/NewCallDrawer";
import TransferDrawer from "@/components/webrtc/TransferDrawer";
import AgentInBreak from "@/components/agent-console/AgentInBreak";
import TheActivityBox from "@/components/agent-console/TheActivityBox";
import TheActivityInfoBox from "@/components/agent-console/TheActivityInfoBox";
import TheMainAgentContent from "@/components/agent-console/TheMainAgentContent";
import TheModalBreaks from "@/components/agent-console/TheModalBreaks";
import IncomingCall from "@/components/webrtc/IncomingCall";
import TheIntegrationsBox from "@/components/agent-console/TheIntegrationsBox";
import TheAcceptChatWindow from "@/components/agent-console/TheAcceptChatWindow";
import TheConfirmationLogoutModal from "@/components/agent-console/TheConfirmationLogoutModal";
import TheTagsBox from "@/components/agent-console/TheTagsBox";
/* import TheModalTour from "@/components/modal-tour/TheModalTour"; */
import createNotification from "@/plugins/notification";
import Chronometer from "@/components/common/Chronometer";
import TheNewUserDrawer from "@/components/ticket/TheNewUserDrawer";
import TheSearchClient from "@/components/ticket/TheSearchClient";
import TheClientBox from '@/components/agent-console/TheClientBox';
import TheAgentMenu from '@/components/agent-console/TheAgentMenu';
import TheInternalNotesBox from '@/components/agent-console/TheInternalNotesBox';
import AgentNotSignIn from '@/components/agent-console/AgentNotSignIn.vue';
import { EventBus } from '@/plugins/event-bus.js';
import mediaserver from '../api/mediaserver';
import WindowStatus from '@/plugins/window-status'
import TheTransferChat from '@/components/agent-console/TheTransferChat'
import TheTransferCall from '@/components/agent-console/TheTransferCall'

export default {
  name: "AgentConsole",
  title: "Agent Console",
  components: {
    TheTransferCall,
    TheClientBox,
    TheTagsBox,
    TheActivityBox,
    TheMainAgentContent,
    TheActivityInfoBox,
    TransferDrawer,
    AgentInBreak,
    TheModalBreaks,
    TheSendEmailBox,
    CallButtons,
    NewCallDrawer,
    IncomingCall,
    TheIntegrationsBox,
    TheAcceptChatWindow,
    TheSearchTicket,
    TheConfirmationLogoutModal,
    /* TheModalTour, */
    TheNewUserDrawer,
    TheSearchClient,
    TheSystemMessages,
    TheInternalNotesBox,
    TheAgentMenu,
    Chronometer,
    AgentNotSignIn,
    TheTransferChat
  },
  data () {
    return {
      sendEmailTo: "",
      transferDrawerIsVisible: false,
      extensionRegistered: false,
      appReady: false,
      inCallWith: {
        username: "",
        displayname: "",
      },
      incomingCall: false,
      typeTransfer: "call",
      loginClick: false,
      searchTicketOf: "",
      canLoggin: false,
      errorLoggin: false,
      jsep: null,
      answerTimeout: null,
      errorCanLoggin: false,
      janusConnected: false,
      stats: null,
      customer: null,
      loadingCustomer: false,
      showChatDetails: false,
      signOutAudio: new Audio('/sounds/sign-out.mp3'),
      connectedTimeout: null,
      isReconnecting: false,
      disconnectNotification: null,
      isMainWindow: true,
      transferDrawer: false,
      availableToClose: true
    };
  },
  methods: {
    ...mapActions([
      "setAgentJanus",
      "doLogout",
      "doLogin",
      "unBreak",
      "doBreak",
      "setAgentBasic",
      "listenAgent",
      "setInCall",
      "checkIfLogged",
      "fetchBreaks",
      "updateStatus",
      "listenAgentsDashboard",
      "listenQueuesDashboardArray",
      "doCallCenterLogin",
      "setPendingChatAcept",
      "removeClick2Call",
      "closeLastCall",
      "doOsticketAuth",
      "fetchTickets"
    ]),
    ...mapActions('audit', [
      'saveAgentErrorLogin'
    ]),
    handleLogout () {
      if (this.activeChats.length > 0) {
        this.$refs.TheConfirmationLogoutModal.show = true;
        return;
      }

      this.doLogout();
    },
    showTransferDrawer (data) {
      this.transferDrawer = true
      this.typeTransfer = data.type
      /* this.$refs.transferDrawer.drawer = true;
      this.$refs.transferDrawer.typeTransfer = data.type;
      this.$refs.transferDrawer.data = data.data; */
    },
    showNewCallDrawer () {
      this.$refs.newCallDrawer.show = true;
    },
    showNewUserDrawer () {
      this.$refs.newUserDrawer.show = true;
    },
    chatAccepted () {
      this.setPendingChatAcept(null);
    },
    closeWindow () {
      this.setPendingChatAcept(null);
    },
    showModalBreaks () {
      this.$refs.modalBreak.show = true;
    },
    showBoxSendEmail (email) {
      this.sendEmailTo = email;
    },
    call (value) {
      this.$refs.newCallDrawer.form.name = value;
      this.$refs.newCallDrawer.call({ number: value, title: value }, true);
    },
    showBoxSearchTicket (email) {
      this.searchTicketOf = email;
      setTimeout(() => {
        this.$refs.theSearchTicket.searchTicket();
      }, 200);
    },
    closeEmailBox () {
      this.sendEmailTo = "";
    },
    callbackSocketRemote (text) {
      this.$store.dispatch('addTranscription', { transcription: { timestamp: new Date().getTime(), text, client: true } })
    },
    callbackSocketLocal (text) {
      this.$store.dispatch('addTranscription', { transcription: { timestamp: new Date().getTime(), text, client: false } })
    },
    async initJanus () {
      await mediaserver.destroyAgentSession();
      return new Promise((resolve) => {
        const agent = this.agent;
        const extension = agent.extension;
        if (extension) {
          if (this.janus !== null) {
            this.janus.registerSipExtension();
            resolve();
            return;
          }
          const stunServer = extension.stunServer ?? null;
          const _JANUS = janus.init(
            extension.janus_server.servers,
            extension.janus_server.secret,
            {
              number: parseInt(extension.extension),
              displayname: this.agent.name,
              domain: extension.domain,
              secret: extension.secret
            },
            stunServer,
            this.agent.enableTranscription,
            this.organizationId
          );

          this.setAgentJanus(_JANUS)

          _JANUS.onSipMessage((message, jsep) => {
            if (message.result) {
              if (message.result.event === 'registration_failed') {
                this.saveAgentErrorLogin({
                  reason: 'Registration forbidden (Bad auth)',
                  code: '4131',
                  by: 'web'
                })
              }

              if (message.result.event === "registered") {
                _JANUS.attachAudio(document.querySelector("#agentConsoleAudio"));
                this.extensionRegistered = true;
                this.$store.dispatch("doCallLogin")
                if (this.getLoggedInCallCenter) {
                  this.$store.dispatch("SET_DO_UNREGISTER_REGISTER");
                }
              }

              if (message.result.event === "registration_failed") {
                this.extensionRegistered = false;
              }

              if (message.result.event === "incomingcall" && this.getLoggedInCallCenter) {
                this.jsep = jsep;
                this.inCallWith.username = message.result.username;
                this.inCallWith.displayname = message.result.displayname.replace('"', '').replace('"', '')
                if (this.agent.automatic_answer_call) {
                  this.answerTimeout = setTimeout(() => {
                    try {
                      this.janus
                        .answer(this.jsep);
                    } catch (error) {
                      console.log(error);
                    }
                  }, 1000)
                } else {
                  this.incomingCall = true;
                  this.$refs.incomingCall.toggleVisible();
                  createNotification("Tienes una llamada entrante", this.interactWithPage);
                }
              }

              if (message.result.event === "accepted") {
                if (this.incomingCall) {
                  if (this.$refs.incomingCall) {
                    this.$refs.incomingCall.toggleVisible();
                  }
                }

                let callerid = this.inCallWith.displayname;

                if (this.$refs.newCallDrawer.show && this.$refs.newCallDrawer.callTo) {
                  callerid = this.$refs.newCallDrawer.callTo.number
                }

                if (callerid) {
                  this.$message({
                    showClose: true,
                    message: this.$t("agent-console.you-are-in-call-with", { callerid }),
                    type: "success",
                    duration: 10000 ,
                  });
                }

                this.setInCall();
                this.updateStatus("busy");
                if (this.$refs.newCallDrawer.show) {
                  this.$refs.newCallDrawer.closeAndReset();
                }
                //this.$refs.ringtone.pause();
                if (this.agent.automatic_answer_call) {
                  createNotification("Se atendio la llamada");
                }
              }

              if (message.result.event === "hangup") {
                this.hangup()
              }

              if (
                message.result.event == "progress" ||
                message.result.event == "accepted" ||
                message.result.event == "hangup"
              ) {
                clearTimeout(this.answerTimeout);
                this.answerTimeout = null;
                this.incomingCall = false;
                if (this.$refs.newCallDrawer) {
                  if (this.$refs.newCallDrawer.show) {
                    this.$refs.newCallDrawer.pauseRingback();
                  }
                }
              }

              if (message.result.event === 'holding' || message.result.event === 'resuming') {
                this.$store.dispatch('setHoldingValue', message.result.event === 'holding')
              }
            }
          });

          _JANUS.onCallingError(() => {
            if (this.$refs.newCallDrawer) {
              if (this.$refs.newCallDrawer.show) {
                this.$refs.newCallDrawer.closeAndReset();
              }
            }
          });

          _JANUS.onErrorAttachSip((error) => {
            this.$alert(error);
          });

          _JANUS.onDestroyedSession(this.onDestroySession);
          _JANUS.attachAudio(this.$refs.sipConsoleAudio);

          _JANUS.startConnection().then(() => {
              mediaServerApi.saveAgentSession(_JANUS.server(), _JANUS.sessionId())
              this.appReady = true;
              this.janusConnected = true;

              /* if (this.disconnectNotification) {
                  this.disconnectNotification.close();
                  this.disconnectNotification = null
                  this.$notify({
                    type : 'success', 
                    title: 'Media server online', 
                    message: ' Se ha recuperado la conexión con el media server',
                    position: 'bottom-left',
                })
              } */
              this.handleJanusConnected()
              resolve();
            })


        } else {
          return resolve();
        }
      });
    },
    onDestroySession() {
      this.janusConnected = false;

      if (this.incomingCall) {
        this.$refs.incomingCall.toggleVisible();
        this.incomingCall = false;
      }

      if (this.connectedTimeout) {
        clearTimeout(this.connectedTimeout)
      }

      if (this.janus) {
        this.janus.stopAllTracks();
      }
      this.setAgentJanus(null)

      //console.log(`La sesion de Janus fue destruida. Tengo que generar una nueva`)
      setTimeout(() => {
        if (this.getLogged && this.agent.call && this.isMainWindow) {
          this.initJanus()
        }
      },5000)
    },
    handleJanusOnAgentLogout() {
      if (this.agent.call && this.janus) {
        this.janus.destroy()
      }
    },

    // PARA QUE TODO ESTO FUNCIONE
    // SE TIENE QUE QUITAR DEL CONECTOR
    // QUE REGISTRE CUANDO SE DEREGISTRA LA EXTENSION
    handleJanusConnected() {
      if (!this.janus) {
        return;
      }
      if (this.connectedTimeout) {
        clearTimeout(this.connectedTimeout);
      }

      this.connectedTimeout = setTimeout(async () => {
        this.janusConnected = this.janus.isConnected();

        if (!this.janusConnected && !this.isReconnecting) {
          this.isReconnecting = true;
          /* if (!this.disconnectNotification) {
            this.disconnectNotification = this.$notify({
              type : 'warning', 
              title: 'Media server offline',
              message: 'Se ha perdido conexión contra el media server. Intentando re-conectar',
              position: 'bottom-left',
              duration: 0,
            })
          } */

          if (this.incomingCall) {
            this.$refs.incomingCall.toggleVisible();
            this.incomingCall = false;
          }

          try {
            //console.log('Me quedé sin conexión, intentando reconectar...');
            await this.reconnectJanus();
            /* this.disconnectNotification.close();
            this.disconnectNotification = null
            this.$notify({
              type : 'success', 
              title: 'Media server online', 
              message: ' Se ha recuperado la conexión con el media server',
              position: 'bottom-left',
            }) */
          } catch (err) {
            if (/No such session/.test(err)) {
              //this.janus.destroy()
              this.onDestroySession()
              return
            }
          } finally {
            this.isReconnecting = false;
            //console.log('Continuo');
          }
        }

        if (this.janus && this.isMainWindow) {
          this.handleJanusConnected();
        }
      }, 1000);
    },
    async reconnectJanus() {
      if (!this.janus) {
        throw new Error('Janus is not setted');
      }
      //console.log(`Intentando reconectar...`);
    
      return new Promise((resolve, reject) => {
        this.janus.reconnect({
          success: () => {
            //console.log('Reconexion exitosa');
            resolve();
          },
          error: async (err) => {
            reject(err)
          } 
        });
      });
    },
    hangup () {
      if (this.incomingCall) {
        this.incomingCall = false;
        if (this.$refs.incomingCall) {
          this.$refs.incomingCall.toggleVisible();
        }
      }

      if (this.getIsInCall) {
        this.$refs.hangupSound.volume = 0.5;
        this.$refs.hangupSound.play();
        this.$refs.hangupSound.currentTime = 0;

        const lastUniqueId = this.$store.getters['getLastCallUniqueId']
        if (this.janus) {
          this.janus.setUniqueId(lastUniqueId)
        }
      }

      this.setInCall(false);
      this.inCallWith.username = "";
      this.inCallWith.displayname = "";
      this.updateStatus("connected");

      if (this.$refs.newCallDrawer) {
        if (this.$refs.newCallDrawer.show) {
          this.$refs.newCallDrawer.closeAndReset();
        }
      }

      if (this.$refs.transferDrawer) {
        this.$refs.transferDrawer.close();
      }

      if (this.$refs.ringtone) {
        this.$refs.ringtone.pause();
      }

      if (this.click2call) {
        this.removeClick2Call();
      }

      this.closeLastCall();
      this.$store.commit("SET_CALLING_FROM_MAILCENTER", false);
      this.$store.dispatch('setHoldingValue', false)
    },
    handleQuickButton(button) {
      if (this.$refs.newCallDrawer) {
        this.$refs.newCallDrawer.externalCall(button.value);
      }
    },
    toggleShowDetails(){
      this.showChatDetails = !this.showChatDetails
      localStorage.setItem('showChatDetails',this.showChatDetails)
    }
  },
  computed: {
    ...mapGetters({
      availableForChats: "getAvailableForChats",
      outputDevice: "getOutputAudioDevice",
      inputDevice: "getInputAudioDevice",
      volume: "getOutputAudioVolume",
      hasToReloadJanus: "reloadJanus",
      click2call: "getClick2Call",
      janus: "getAgentJanus",
      activityList: "getActivityList",
      interactWithPage: 'getInteractWithPage',
      user: 'getUser',
      DO_UNREGISTER_REGISTER: "DO_UNREGISTER_REGISTER",
      isLoggedInCallCenter: "getLoggedInCallCenter",
      getActiveItem: 'getActiveItem',
      getIsInCall: 'getIsInCall',
      getChatDepartments: 'getChatDepartments',
      isLoggedInChatCenter: 'getLoggedInChatCenter',
      agent: 'getAgent',
      getLogged: 'getLogged'
    }),
    ...mapGetters([
      "getLoggedInCallCenter",
      "getLoggedInChatCenter",
      "getShowAcceptChatWindow",
      "getActivityList",
    ]),
    quickDialButtons() {
      return this.agent.extension ? this.agent.extension.quick_buttons.filter(b => b.type === 'quick_dial') : []
    },
    clientInfoCrudEnabled () {
      return this.getActiveItem.type === "chat" && this.getActiveItem.createdWitChatEngine && this.getActiveItem.active;
    },
    isLastActivityItemActive() {
      const items = this.activityList.filter(item => item.type === 'call');
      return items[0] ? items[0].active : false
    },
    showAcceptChat () {
      return this.getShowAcceptChatWindow;
    },
    getLoggedStatus () {
      return this.$store.getters['getLogged'];
    },
    getBreakStatus () {
      return this.$store.getters['getBreak'];
    },
    isCallButtonEnabled() {
      if (this.extensionRegistered && this.getLoggedInCallCenter && !this.getIsInCall) {
        return true;
      }
      return false;
    },
    textCallLogged () {
      return this.getLoggedInCallCenter
        ? this.$t("agent-console.online")
        : this.$t("agent-console.offline");
    },
    textChatLogged () {
      return this.getLoggedInChatCenter
        ? this.$t("agent-console.online")
        : this.$t("agent-console.offline");
    },
    tabId () {
      return localStorage.getItem("tabCount");
    },
    isAgentLogged () {
      if (
        this.getActiveItem &&
        this.agent.id &&
        this.getLoggedInChatCenter
      ) {
        return true;
      }
      return false;
    },
    activeChats () {
      return this.getActivityList.filter(
        (item) => item.active && item.type === "chat"
      );
    },
    organizationId () {
			return this.$store.getters["getAgent"].organization_id.toString()
		},
    getPhoneOfActivity() {
      if (this.getActiveItem) {
        if (this.getActiveItem.type === 'chat') {
          return this.getActiveItem.clientinfo.find(prop => prop.label === 'Phone')?.value
        }
      }
      return null
    },
    getUniqueIdActiveCall() {
      return this.$store.getters['getCallKeyActive']
    },
    integrations() {
      if (!this.getActiveItem) {
        return []
      }

      return this.getActiveItem.type === 'chat' ? this.getActiveItem.integrations : (this.$store.getters['agentConsoleCall/getActiveActivityCall']?.integrations ?? [])
    },
    clientInfo() {
      if (!this.getActiveItem) {
        return []
      }

      return this.getActiveItem.type === 'chat' ? this.getActiveItem.clientinfo : (this.$store.getters['agentConsoleCall/getActiveActivityCall']?.clientInfo ?? [])
    }
  },
  watch: {
    /* getUniqueIdActiveCall(value) {
      if (value && this.janus) {
        this.janus.setUniqueId(value);
      }
    },*/
    getIsInCall(value, old) {
      console.log({ log: 'agent-console-watch', payload: { newValue: value, oldValue: old }})
    },
    DO_UNREGISTER_REGISTER(value) {
      if (value && this.janus) {
        this.janus.unregisterSipExtension();
      }
    },
    volume (value) {
      document.querySelector("#agentConsoleAudio").volume = value;
    },
    outputDevice (value) {
      if (document.querySelector("#agentConsoleAudio").setSinkId) {
        document.querySelector("#agentConsoleAudio").setSinkId(value);
      }
    },
    inputDevice (value) {
      this.janus.changeMicrophone(value);
    },
    click2call (value) {
      if (value) {
        this.call(value.callTo);
      }
    },
    /* lastActivityList (value, oldValue) {
      if (!value && oldValue) {
        this.hangup();
      }
    },
   /*  activityList: {
      handler: function (value, oldValue) {
        if (value.length !== 0) {
          const newItem = value[0];
          if (newItem.type === 'call' && newItem.active) {
            if (oldValue[0]) {
              const oldItem = oldValue[0];
              if (oldItem.key !== newItem.key) {
                this.setInCall();
              }
            } else {
              this.setInCall();
            }
          }
        }
      },
      deep: true,
    },
  ,
    /* isLoggedInCallCenter(value) {
      if (value && this.janus) {
        agentapi.saveJanusConnection(this.janus.server(), this.janus.sessionId());
      }
    }, */
    async getActiveItem(item) {
      if (item && item.type === 'chat' && this.agent.customersEnabled && this.getPhoneOfActivity) {
        this.customer = null
        this.loadingCustomer = true
        try {
          this.customer = await this.$store.dispatch('customers/fetchCustomerByPhone', { organizationId: this.organizationId, phone: this.getPhoneOfActivity })
          if(this.customer){
            this.customer.values = [...this.$store.getters['customers/getCustomerForm'].filter((element) => !this.customer.values.find((value) => value.key == element.key)), ...this.customer.values]
          }
        } finally {
          this.loadingCustomer = false
        }
      }

      if (!item) {
        this.transferDrawer = false;
      }
    },
    getLoggedStatus (value) {
      if (!value) {
        createNotification('Se ha cerrado la sesión de agente')
        this.signOutAudio.play()
        if (this.agent.call && this.janus) {
          this.handleJanusOnAgentLogout()
          return
        }
      }

      if (value && this.agent.call) {
        this.initJanus()
      }
    },
    isMainWindow(value, oldValue) {
      if (!this.agent.call) {
        return
      }

      if (!value && this.janus) {
        this.janus.destroy()
        return
      }

      if (value && !oldValue && this.getLogged) {
        this.initJanus()
      }
    }
  },
  beforeMount() {
    this.listenAgent()
  },
  async created () {
    this.windowStatus = new WindowStatus('_AGENT_CONSOLE');
    this.windowStatus.start(true, (isMainWindow) => {
      this.isMainWindow = isMainWindow
    })

    this.title = this.$t("main-menu.agent-console.title");
/*     const organizationArray = [this.agent.organization_id]
    this.listenAgentsDashboard(this.agent.organization_id);
    this.listenQueuesDashboardArray(organizationArray) */
    if(!localStorage.getItem('showChatDetails')){
      localStorage.setItem('showChatDetails', true)
    }
    if(!localStorage.getItem('enabledPendingNotification')){
      localStorage.setItem('enabledPendingNotification', true)
    }
    if(!localStorage.getItem('enabledNewMessageNotification')){
      localStorage.setItem('enabledNewMessageNotification', true)
    }
    this.showChatDetails = JSON.parse(localStorage.getItem('showChatDetails')) ?? true

    if (this.agent.call) {
        this.fetchBreaks();
    }

    if (this.agent.mail) {
      this.fetchTickets({ onlyAssigned: true, status: 'open', nopagination: true })
    }

    /* if (this.agent.chat) {
      this.$store.dispatch('departments/all', { pagination: false, ["organization.id"]: this.agent.organization_id })
    } */
    EventBus.$on('newCustomer', async ({ customerId }) => {
      this.customer = null
      this.loadingCustomer = true
      try {
        this.customer = await this.$store.dispatch('customers/fetchCustomerById', { organizationId: this.organizationId, customerId })
      } finally {
        this.loadingCustomer = false
      }
    })

    this.$store.dispatch('listenAgentsDashboard', this.agent.organization_id)
  },
 /*  mounted () {
    this.$title = this.$t("main-menu.agent-console.title");
    setTimeout(() => {
      if (this.$route.query.t && !this.getLoggedStatus) {
        this.doAgentLogin();
      }
    }, 1000);
  } */
  /* beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.agent.mail) {
        vm.fetchTickets({ onlyAssigned: true, status: 'open', nopagination: true })
      }
    })
  } */
};
</script>

<style scoped>


.agent-logged {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.console {
  align-items: stretch;
  display: inline-flex;
  padding-top: var(--column);
  width: 100%;
  max-height: 91vh;
  gap: var(--column)
}

.console-header {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.console .box {
  background-color: white;
  border-radius: var(--radius);
  padding: var(--column);
}

.console .big-column {
  display: flex;
  flex-direction: column;
  margin: 0 var(--column);
  flex-grow: 1
}

.console .big-column>div {
  margin-bottom: var(--column);
}

.console .big-column>div:last-child {
  margin-bottom: 0;
}

.console .column {
  width: 25%;
}

.console .column:first-child {
  display: flex;
  flex-direction: column;
}

.console .column:last-child .box {
  margin-bottom: var(--column);
}

.console .last-column {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  overflow-y: auto;
}

.agent-info {
  margin-bottom: var(--column);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agent-info ul {
  display: inline-flex;
}

.agent-info ul li {
  list-style: none;
  font-size: 13px;
  margin-right: calc(var(--column) / 2);
  color: var(--blue-grey);
}

.tab-in-use {
  font-size: 13px;
}

.agent-info ul li.active {
  color: var(--green);
}

/** Esto es de OTRO COMPONENTE */
.call .fas,
.call .icon-keypad {
  background-color: white;
  border-radius: 50%;
  color: var(--blue-grey);
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 40px;
  transition: all 0.2s ease-in-out;
  margin-left: 10px;
}

.call .hangup {
  background-color: var(--red);
  color: white;
  transform: rotate(-134deg);
}

.console-buttons {
  display: inline-flex;
  gap: 8px;
}

.here:hover {
  cursor: pointer;
}

.agent-in-break-mobile {
  display: none;
}

.main-agent-content {
  flex: 1
}

.agent-activity {
  display: flex;
  flex-direction: column;
  min-width: 350px
}

.not-available {
  color: var(--orange)
}

.agent-info ul li.active.media-server-not-connected {
  color: var(--red) 
}

.el-button+.el-button {
  margin: 0!important
}
.agent-console__side-bar-container{
  overflow: hidden;
  transition: all 2s;
  justify-content: flex-end;
}
.agent-console__side-bar-controls{
  padding: 10px;
  cursor: pointer;
}
.agent-console__side-bar-controls-container--open{
  display: flex;
  justify-content: center;
}
.agent-console__side-bar-controls-container{
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: #fff;

}
</style>
